<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog">
        <el-form ref="formValidate" :model="model" label-width="120px">
            <el-form-item label="分类名称：" prop="name">
                <span>{{model.name}}</span>
            </el-form-item>
            <el-form-item label="分类编码：" prop="ccode">
                <span>{{model.ccode}}</span>
            </el-form-item>
            <el-form-item label="父ID：" prop="pid">
                <span>{{model.pid}}</span>
            </el-form-item>
            <el-form-item label="排序：" prop="order_index">
                <span>{{model.order_index}}</span>
            </el-form-item>
            <el-form-item label="是否显示：" prop="is_show">
                <span>{{model.is_show}}</span>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeDialog" size="medium">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'goodsCateInfo',
    mixins: [editutil],
    data() {
        return {
            model: {
                name: '',
                ccode: '',
                pid: '',
                order_index: '',
                is_show: '',
            },
            getObj:{
                url:'/api/admin/goodscate/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
        };
    },
    methods: {}
};
</script>